import React, { useEffect, useState } from 'react'
import '../css/landingAdmin.css'
import '../css/response.css'
import { AuthServices } from '../util/authServices'

const RegistraServicio = ({ setUserSession, setViewAdminZone, userSession, scortService, setCargando, toast }) => {

    const [form, setForm] = useState({
        fechaInicio: '',
        fechaFin: '',
        horaInicio: '',
        horaFin: '',
        cantidadHoras: '',
        descuento: '',
        pagoPorcentaje: '',
        pagoTransporte: '',
        certificado: null,
    })

    const [campanias, setCampanias] = useState([])
    const [historial, setHistorial] = useState([])
    const [executeControlService, setExecuteControlService] = useState(true)

    useEffect(() => {
        getSeriviciosScortService()
        getCampaniasVigentes()
    }, [executeControlService])

    useEffect(() => {
        if (form.horaInicio && form.horaFin) {
            const horasCalculadas = calculateHours(
                form.horaInicio,
                form.horaFin,
                form.fechaInicio,
                form.fechaFin
            )

            let valServicio = 0;
            let ant = 0;
            if (horasCalculadas && scortService) {
                const hours = parseFloat(horasCalculadas);
                if (!isNaN(hours) && hours > 0) {
                    let tarifaStr = '';
                    if (hours < 3.0) {
                        tarifaStr = scortService.tarifa1;
                    } else if (hours < 5.0) {
                        tarifaStr = scortService.tarifa2;
                    } else {
                        tarifaStr = scortService.tarifa3;
                    }
                    const tarifaNumeric = parseTarifa(tarifaStr);
                    valServicio = tarifaNumeric * hours;

                    const pct = getSelectedDiscountPercentage();
                    if (pct > 0) {
                        valServicio = valServicio * (1 - pct / 100);
                    }

                    ant = valServicio * 0.30;
                }
            }

            setForm((prev) => ({
                ...prev,
                cantidadHoras: horasCalculadas,
                pagoPorcentaje: ant > 0 ? Math.round(ant).toString() : ''
            }))
        } else {
            setForm((prev) => ({
                ...prev,
                cantidadHoras: '',
                pagoPorcentaje: ''
            }))
        }
    }, [form.fechaInicio, form.fechaFin, form.horaInicio, form.horaFin, form.descuento, scortService, campanias])

    const closeSession = () => {
        setUserSession({
            nombre: "",
            apellido: "",
            usuario: "",
            role: "USUARIO_LOGIN"
        })
        sessionStorage.removeItem('userSessionStorage')
    }

    const actionNavigate = (action) => {
        setViewAdminZone(action)
    }

    const calculateHours = (horaInicio, horaFin, fechaInicio, fechaFin) => {
        if (!horaInicio || !horaFin) return ''
        const [horaInicioH, horaInicioM] = horaInicio.split(':').map(Number)
        const [horaFinH, horaFinM] = horaFin.split(':').map(Number)
        let minutosInicio = horaInicioH * 60 + horaInicioM
        let minutosFin = horaFinH * 60 + horaFinM
        if (minutosFin < minutosInicio && fechaInicio && fechaFin) {
            const inicio = new Date(fechaInicio)
            const fin = new Date(fechaFin)
            const diasDiferencia = Math.floor((fin - inicio) / (1000 * 60 * 60 * 24))
            if (diasDiferencia > 0) {
                minutosFin += 24 * 60
            }
        } else if (minutosFin < minutosInicio) {
            minutosFin += 24 * 60
        }
        const horas = (minutosFin - minutosInicio) / 60
        return horas > 0 ? horas.toFixed(2) : ''
    }

    const handleChange = ({ target }) => {
        const { name, value } = target
        setForm((prev) => ({
            ...prev,
            [name]: value,
        }))
    }

    const handleTransporteChange = ({ target }) => {
        const { value } = target;
        const cleanNumber = value.replace(/\D/g, '');
        if (cleanNumber === '') {
            setForm((prev) => ({
                ...prev,
                pagoTransporte: ''
            }));
            return;
        }
        const numericVal = parseInt(cleanNumber, 10);
        setForm((prev) => ({
            ...prev,
            pagoTransporte: formatCurrency(numericVal)
        }));
    }

    const handleFileChange = ({ target }) => {
        setForm((prev) => ({
            ...prev,
            certificado: target.files?.[0] || null,
        }))
    }

    const handleSubmit = async () => {
        setCargando(true)
        const authServices = new AuthServices();
        try {
            const body = {
                scortIdProcesamiento: scortService.idProcesamiento,
                fechaInicio: form.fechaInicio,
                fechaFin: form.fechaFin,
                horaInicio: form.horaInicio,
                horaFin: form.horaFin,
                descuento: form.descuento,
                pagoPorcentaje: form.pagoPorcentaje,
                pagoTransporte: form.pagoTransporte,
            }
            const response = await authServices.requestPost(body, 19);
            const { estado, mensaje } = response.data;
            if (estado) {
                setForm({
                    fechaInicio: '',
                    fechaFin: '',
                    horaInicio: '',
                    horaFin: '',
                    cantidadHoras: '',
                    descuento: '',
                    pagoPorcentaje: '',
                    pagoTransporte: '',
                    certificado: null,
                })
                setExecuteControlService(!executeControlService)
            }
            toast(mensaje)
            setCargando(false);
        } catch (error) {
            setCargando(false);
            toast("Error de comunicación")
        }
    }

    const getSeriviciosScortService = async () => {
        setCargando(true)
        const authServices = new AuthServices();
        try {
            const body = {
                scortIdProcesamiento: scortService.idProcesamiento,
            }
            const response = await authServices.requestPost(body, 20);
            const { estado, mensaje, objeto } = response.data;
            if (estado) {
                setHistorial(objeto)
            } else {
                toast(mensaje)
            }
            setCargando(false);
        } catch (error) {
            setCargando(false);
            toast("Error de comunicación")
        }
    }

    const getCampaniasVigentes = async () => {
        setCargando(true)
        const authServices = new AuthServices();
        try {
            const response = await authServices.requestPost({}, 22);
            const { estado, mensaje, objeto } = response.data;
            if (estado) {
                setCampanias(objeto || [])
            } else {
                toast(mensaje)
            }
            setCargando(false);
        } catch (error) {
            setCargando(false);
            toast("Error de comunicación")
        }
    }

    const getTarifaCorrespondiente = () => {
        if (!form.cantidadHoras || !scortService) return ''
        const hours = parseFloat(form.cantidadHoras)
        if (isNaN(hours) || hours <= 0) return ''

        let tarifa = '';
        if (hours < 3.0) {
            tarifa = scortService.tarifa1 || '';
        } else if (hours < 5.0) {
            tarifa = scortService.tarifa2 || '';
        } else {
            tarifa = scortService.tarifa3 || '';
        }
        return formatCurrency(parseTarifa(tarifa));
    }

    const getValorServicio = () => {
        if (!form.cantidadHoras || !scortService) return '$ 0';
        const hours = parseFloat(form.cantidadHoras);
        if (isNaN(hours) || hours <= 0) return '$ 0';

        let tarifaStr = '';
        if (hours < 3.0) {
            tarifaStr = scortService.tarifa1;
        } else if (hours < 5.0) {
            tarifaStr = scortService.tarifa2;
        } else {
            tarifaStr = scortService.tarifa3;
        }
        const tarifaVal = parseTarifa(tarifaStr);
        let valServicio = tarifaVal * hours;

        const pct = getSelectedDiscountPercentage();
        if (pct > 0) {
            valServicio = valServicio * (1 - pct / 100);
        }

        return formatCurrency(valServicio);
    }

    const getValorDescuento = () => {
        if (!form.cantidadHoras || !scortService) return '$ 0';
        const hours = parseFloat(form.cantidadHoras);
        if (isNaN(hours) || hours <= 0) return '$ 0';

        let tarifaStr = '';
        if (hours < 3.0) {
            tarifaStr = scortService.tarifa1;
        } else if (hours < 5.0) {
            tarifaStr = scortService.tarifa2;
        } else {
            tarifaStr = scortService.tarifa3;
        }
        const tarifaVal = parseTarifa(tarifaStr);
        const valServicio = tarifaVal * hours;

        const pct = getSelectedDiscountPercentage();
        if (pct <= 0) return '$ 0';

        const valorDescuento = valServicio * (pct / 100);
        return `${formatCurrency(valorDescuento)} (${pct}%)`;
    }

    const getDiscountValueForHistory = (item) => {
        if (!item.horas || !scortService) return '$ 0';
        const hours = parseFloat(item.horas);
        if (isNaN(hours) || hours <= 0) return '$ 0';

        let tarifaStr = '';
        if (hours < 3.0) {
            tarifaStr = scortService.tarifa1;
        } else if (hours < 5.0) {
            tarifaStr = scortService.tarifa2;
        } else {
            tarifaStr = scortService.tarifa3;
        }
        const tarifaVal = parseTarifa(tarifaStr);
        const valBruto = tarifaVal * hours;

        const pct = item.campaing ? parseFloat(item.campaing.descuentoPorcentaje) : 0;
        if (pct <= 0) return '$ 0';

        const discountAmount = valBruto * (pct / 100);
        return `${formatCurrency(discountAmount)} (${pct}%)`;
    }

    const getValorServicioForHistory = (item) => {
        if (!item.horas || !scortService) return '$ 0';
        const hours = parseFloat(item.horas);
        if (isNaN(hours) || hours <= 0) return '$ 0';

        let tarifaStr = '';
        if (hours < 3.0) {
            tarifaStr = scortService.tarifa1;
        } else if (hours < 5.0) {
            tarifaStr = scortService.tarifa2;
        } else {
            tarifaStr = scortService.tarifa3;
        }
        const tarifaVal = parseTarifa(tarifaStr);
        let valServicio = tarifaVal * hours;

        const pct = item.campaing ? parseFloat(item.campaing.descuentoPorcentaje) : 0;
        if (pct > 0) {
            valServicio = valServicio * (1 - pct / 100);
        }

        return formatCurrency(valServicio);
    }

    const getTarifaPlenaForHistory = (item) => {
        if (!item.horas || !scortService) return '$ 0';
        const hours = parseFloat(item.horas);
        if (isNaN(hours) || hours <= 0) return '$ 0';

        let tarifaStr = '';
        if (hours < 3.0) {
            tarifaStr = scortService.tarifa1;
        } else if (hours < 5.0) {
            tarifaStr = scortService.tarifa2;
        } else {
            tarifaStr = scortService.tarifa3;
        }
        const tarifaVal = parseTarifa(tarifaStr);
        return formatCurrency(tarifaVal * hours);
    }

    const getSelectedDiscountPercentage = () => {
        if (!form.descuento || campanias.length === 0) return 0;
        const selected = campanias.find(c => c.id.toString() === form.descuento.toString());
        return selected ? parseFloat(selected.descuentoPorcentaje) : 0;
    }

    const parseTarifa = (tarifaStr) => {
        if (!tarifaStr) return 0;
        const cleanStr = tarifaStr.replace(/[\$\.\s]/g, '');
        const value = parseInt(cleanStr, 10);
        return isNaN(value) ? 0 : value;
    }

    const formatCurrency = (val) => {
        if (val === undefined || val === null || isNaN(val)) return '$ 0';
        return '$ ' + Math.round(val).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }

    return (
        <>
            <div className='div-container'>
                <div className="row m-0">
                    <div className="col-6 col-sm-6 col-md-6 col-lg-6" >
                        <div className='div-name-user'>
                            <p>{`${userSession.nombre} ${userSession.apellido}`}</p>
                        </div>
                    </div>
                    <div className="col-6 col-sm-6 col-md-6 col-lg-6 control-margin" >
                        <div className='div-close-info' style={{ height: "3rem" }}>
                            <button className='btn btn-link btn-close-modal' onClick={() => actionNavigate('VISTA_PRELIMINAR')} >Volver</button>
                            <button className='btn btn-link btn-close-modal' onClick={() => closeSession()} >Cerrar</button>
                        </div>
                    </div>
                </div>
                <hr className='hr-report' />
            </div>
            <div className='div-container'>
                <div className="row m-0">
                    {/* Tarjeta de Presentación / Perfil */}
                    <div className="col-12 col-md-4 col-lg-3">
                        <div className="card shadow-sm border-danger mb-4" style={{ backgroundColor: '#2b2121', color: 'white', borderRadius: '12px' }}>
                            <div className="card-body">
                                <h5 className="card-title text-danger fw-bold" style={{ borderBottom: '1px solid #FF1A1A', paddingBottom: '8px' }}>
                                    Datos de Escort
                                </h5>
                                <div className="mt-3">
                                    <p className="my-3" style={{ fontSize: '0.9rem' }}>
                                        <strong>Nombre Real:</strong> <br />
                                        <span className="text-muted">{scortService?.nombre} {scortService?.apellido}</span>
                                    </p>
                                    <p className="my-3" style={{ fontSize: '0.9rem' }}>
                                        <strong>Nombre Artístico:</strong> <br />
                                        <span className="text-warning fw-bold">{scortService?.nombreArtistico} {scortService?.apellidoArtistico}</span>
                                    </p>
                                    <p className="my-0" style={{ fontSize: '0.9rem' }}>
                                        <strong>Cédula:</strong> <br />
                                        <span className="text-muted">{scortService?.cedula}</span>
                                    </p>
                                    <h6 className="text-danger fw-bold mt-3" style={{ borderBottom: '1px solid #FF1A1A', paddingBottom: '4px', fontSize: '0.95rem' }}>
                                        Tarifas Establecidas
                                    </h6>
                                    <ul className="list-unstyled mt-2" style={{ fontSize: '0.85rem' }}>
                                        <li className="d-flex justify-content-between my-3">
                                            <span>1 Hora:</span>
                                            <span className="text-success fw-bold">{formatCurrency(parseTarifa(scortService?.tarifa1))}</span>
                                        </li>
                                        <li className="d-flex justify-content-between my-0">
                                            <span>3 Horas:</span>
                                            <span className="text-success fw-bold">{formatCurrency(parseTarifa(scortService?.tarifa2) * 3)}</span>
                                        </li>
                                        <li className="d-flex justify-content-between my-3">
                                            <span>5+ Horas:</span>
                                            <span className="text-success fw-bold">{formatCurrency(parseTarifa(scortService?.tarifa3) * 5)}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Formulario de Registro */}
                    <div className="col-12 col-md-8 col-lg-6">
                        <h3 className='btn-close-modal mt-0'>Registrar Servicio</h3>
                        <div className="row m-0">
                            {/* Columna de Datos de Entrada (Formulario) */}
                            <div className="col-12 col-lg-12">
                                <div className="row m-0">
                                    <div className="col-12 col-sm-6 col-md-6 mb-3" >
                                        <div className='div-inputs-login'>
                                            <p className='p-label-form'> Fecha de inicio </p>
                                            <input type='date' className='form-control' name='fechaInicio' value={form.fechaInicio} onChange={handleChange} />
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-6 col-md-6 mb-3" >
                                        <div className='div-inputs-login'>
                                            <p className='p-label-form'> Fecha fin </p>
                                            <input type='date' className='form-control' name='fechaFin' value={form.fechaFin} onChange={handleChange} />
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-6 col-md-6 mb-3" >
                                        <div className='div-inputs-login'>
                                            <p className='p-label-form'> Hora inicio </p>
                                            <input type='time' className='form-control' name='horaInicio' value={form.horaInicio} onChange={handleChange} />
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-6 col-md-6 mb-3" >
                                        <div className='div-inputs-login'>
                                            <p className='p-label-form'> Hora fin </p>
                                            <input type='time' className='form-control' name='horaFin' value={form.horaFin} onChange={handleChange} />
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-6 col-md-6 mb-3" >
                                        <div className='div-inputs-login'>
                                            <p className='p-label-form'> % Descuento </p>
                                            <select className='form-control' name='descuento' value={form.descuento} onChange={handleChange}>
                                                <option value=''>Sin Descuento (0%)</option>
                                                {
                                                    campanias.map((campania) => {
                                                        return (
                                                            <option key={campania.id} value={campania.id}>
                                                                {campania.nombreOferta} ({campania.descuentoPorcentaje}%)
                                                            </option>
                                                        )
                                                    })
                                                }
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-6 col-md-6 mb-3" >
                                        <div className='div-inputs-login'>
                                            <p className='p-label-form'> Pago transporte </p>
                                            <input type='text' className='form-control' name='pagoTransporte' value={form.pagoTransporte} onChange={handleTransporteChange} placeholder="$ 0" />
                                        </div>
                                    </div>
                                </div>
                                {
                                    /*
                                }
                                <div className="row mt-2">
                                    <div className="col-12" >
                                        <div className='div-inputs-login'>
                                            <p className='p-label-form'> Certificado de pago </p>
                                                <input disabled type='file' className='form-control' onChange={handleFileChange} />
                                                {form.certificado && (
                                                    <div className='form-text text-muted'>Archivo seleccionado: {form.certificado.name}</div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                {
                                    */
                                }
                            </div>
                        </div>
                        {/* Botón de Registro */}
                        <div className="row m-0 mt-4">
                            <div className="col-12" >
                                <div className='div-inputs-login div-inputs-login-flex'>
                                    <button className='btn btn-primary custom-btn w-100 w-md-auto px-4 py-2' onClick={() => handleSubmit()} >
                                        Registrar servicio
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-8 col-lg-3">
                        {/* Columna de Tarjeta Informativa del Detalle */}
                        <div className="card shadow-sm border-warning h-100" style={{ backgroundColor: '#201a1a', color: 'white', borderRadius: '12px', minHeight: '280px' }}>
                            <div className="card-body d-flex flex-column justify-content-between">
                                <div>
                                    <h5 className="card-title text-warning fw-bold mb-3" style={{ borderBottom: '1px solid #ffc107', paddingBottom: '8px', fontSize: '1rem' }}>
                                        Detalle del Servicio
                                    </h5>
                                    <div className="mt-2">
                                        <div className="d-flex justify-content-between mb-3">
                                            <span style={{ fontSize: '0.85rem', color: '#ccc' }}>Duración:</span>
                                            <span className="fw-bold text-light" style={{ fontSize: '0.9rem' }}>
                                                {form.cantidadHoras ? `${form.cantidadHoras} Hrs` : '---'}
                                            </span>
                                        </div>
                                        <div className="d-flex justify-content-between mb-3">
                                            <span style={{ fontSize: '0.85rem', color: '#ccc' }}>Tarifa base:</span>
                                            <span className="fw-bold text-light" style={{ fontSize: '0.9rem' }}>
                                                {getTarifaCorrespondiente() || '---'}
                                            </span>
                                        </div>
                                        <div className="d-flex justify-content-between mb-3">
                                            <span style={{ fontSize: '0.85rem', color: '#ccc' }}>Descuento:</span>
                                            <span className="fw-bold text-danger" style={{ fontSize: '0.9rem' }}>
                                                {getValorDescuento()}
                                            </span>
                                        </div>
                                        <div className="d-flex justify-content-between mb-3">
                                            <span style={{ fontSize: '0.85rem', color: '#ccc' }}>Valor Servicio:</span>
                                            <span className="fw-bold text-success" style={{ fontSize: '1.05rem' }}>
                                                {getValorServicio()}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className="mt-auto" style={{ borderTop: '1px dotted #555', paddingTop: '15px' }}>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <span style={{ fontSize: '0.9rem', color: '#ffc107', fontWeight: 'bold' }}>Reserva (30%):</span>
                                        <span className="badge bg-warning text-dark px-3 py-2 fw-bold" style={{ fontSize: '1rem', borderRadius: '6px' }}>
                                            {form.pagoPorcentaje ? formatCurrency(parseFloat(form.pagoPorcentaje)) : '$ 0'}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='div-container'>
                <hr className='hr-report mt-4' />
                <h3 className='btn-close-modal mt-3'>Servicios de {scortService?.nombre || ''} {scortService?.apellido || ''}</h3>
                <div className='table-responsive mt-3'>
                    <table className='table table-striped table-bordered'>
                        <thead>
                            <tr>
                                <th className='color-text-table'>Fecha inicio</th>
                                <th className='color-text-table'>Fecha fin</th>
                                <th className='color-text-table'>Hora inicio</th>
                                <th className='color-text-table'>Hora fin</th>
                                <th className='color-text-table'>Tiempo</th>
                                <th className='color-text-table'>Tarifa Plena</th>
                                <th className='color-text-table'>Promoción</th>
                                <th className='color-text-table'>Valor Servicio</th>
                                <th className='color-text-table'>Reserva</th>
                                <th className='color-text-table'>Transporte</th>
                            </tr>
                        </thead>
                        <tbody>
                            {historial.length === 0 ? (
                                <tr>
                                    <td colSpan='10' className='text-center'>No hay servicios registrados</td>
                                </tr>
                            ) : (
                                historial.map((item) => (
                                    <tr key={item.id}>
                                        <td className='color-text-table'>{item.fechaInicio}</td>
                                        <td className='color-text-table'>{item.fechaFin}</td>
                                        <td className='color-text-table'>{item.horaInicio}</td>
                                        <td className='color-text-table'>{item.horaFin}</td>
                                        <td className='color-text-table'>{item.horas} Hrs</td>
                                        <td className='color-text-table'>{getTarifaPlenaForHistory(item)}</td>
                                        <td className='color-text-table'>{getDiscountValueForHistory(item)}</td>
                                        <td className='color-text-table'>{getValorServicioForHistory(item)}</td>
                                        <td className='color-text-table'>{formatCurrency(parseTarifa(item.pagoPorcentaje))}</td>
                                        <td className='color-text-table'>{formatCurrency(parseTarifa(item.pagoTransporte))}</td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    )
}

export default RegistraServicio